import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";


type Props = {
    onActionEdit: (idIndiceReajuste: number | null, openState: boolean) => void,
    onActionDelete: (idIndiceReajuste: number | null, openState: boolean) => void,

}

export const GenerateIndiceReajusteListaColumns = ({
    onActionEdit,
    onActionDelete,

}: Props): GridColDef[] => {

    const computeItemStatusTitle = (status: boolean) => {
        switch (status) {
            case false:
                return "Inativo";
            case true:
                return "Ativo";
            default:
                return "?";
        }
    };

    const computeItemStatusColor = (status: boolean) => {
        switch (status) {
            case false:
                return "yellow"; // em aberto
            case true: // PAGO
                return "green";
            default:
                return "blue";
        }
    };

    const computeItemStatusDescription = (status: boolean) => {
        switch (status) {
            case false:
                return "Indice Inativo";
            case true:
                return "Indice Ativo";
            default:
                return "?";

        }
    };


    return [
        {
            field: "status",
            filterable: false,
            headerName: "Status",
            minWidth: 75,
            width: 75,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },
        {
            field: "codigo",
            filterable: false,
            headerName: "Código",
            flex: 1,
            minWidth: 100,
            maxWidth: 100,
            sortable: false,
        },
        {
            field: "descricao",
            filterable: false,
            headerName: "Descrição",
            flex: 1,
            minWidth: 180,
            sortable: false,
        },
        {
            field: "dataCadastro",
            filterable: false,
            headerName: "Data de Cadastro",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },

        {
            field: 'idIndiceReajuste',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                    </div>
                );
            }
        }

    ];

}